//Cart cross sell global function
window.fetchAndRenderCartCrossSell = function () {
  console.log('called.....');

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      if (!cart.items.length) return;

      const productHandles = cart.items.map(item => item.handle);
      // const productHandles = [...new Set(cart.items.map(item => item.handle))];
      const fetchPromises = productHandles.map(handle =>
        fetch(`/products/${handle}?view=cross-sell`)
          .then(res => res.text())
          .then(html => {
            const temp = document.createElement('div');
            temp.innerHTML = html;

            const dataScript = temp.querySelector('#cross-sell-data');
            if (!dataScript) return null;

            return JSON.parse(dataScript.textContent);
          })
          .catch(err => {
            console.warn(`Cross-sell fetch failed for ${handle}`, err);
            return null;
          })
      );

      return Promise.all(fetchPromises);
    })
    .then(allCrossSellData => {
      if (!allCrossSellData) return;

      const allProducts = [];
      let footwearProducts = [];


      for (const crossSellData of allCrossSellData) {
        if (!crossSellData || !crossSellData.collections) continue;

        // Collect all related products and all footwear products
        for (const col of crossSellData.collections) {

          for (const related of col.relatedCollections) {

            if (related.products && related.products.length) {
              const availableProducts = related.products.filter(p => p.available); //To show only products which are available

              if (related.handle.includes('footwear')) {
                footwearProducts.push(...availableProducts);
              } else {
                allProducts.push(...availableProducts);
              }
            }
          }
        }
      }

      if (!allProducts.length) return;


      const nonFootwearProducts = allProducts.filter(p =>
        !p?.collections?.some(col => col.handle.includes('footwear'))
      );

      const finalSelection = [];

      if (footwearProducts.length > 0) {
        const randomFootwear = footwearProducts[Math.floor(Math.random() * footwearProducts.length)];
        finalSelection.push(randomFootwear);
      }

      const remainingNeeded = 4 - finalSelection.length;
      const remainingPool = [...nonFootwearProducts, ...footwearProducts].filter(
        p => !finalSelection.includes(p)
      );

      while (finalSelection.length < 4 && remainingPool.length) {
        const index = Math.floor(Math.random() * remainingPool.length);
        finalSelection.push(remainingPool.splice(index, 1)[0]);
      }

      // Render
      const container = document.getElementById('cart-drawer-cross-sell-products');
      if (!container) return;

      container.innerHTML = finalSelection
        .map(product => product.smallCardHtml)
        .join('');

    })
    .catch(err => console.warn('Cross-sell multi-fetch failed', err));
};




let productVariants;
let firstAvailableVariant;
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data,
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get("quantity-selector")) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector(".qty");
      this.step = this.input.getAttribute("step");
      this.changeEvent = new Event("change", {
        bubbles: true,
      });
      // Create buttons
      this.subtract = this.querySelector(".minus");
      this.add = this.querySelector(".plus");

      // Add functionality to buttons
      this.subtract.addEventListener("click", () =>
        this.change_quantity(-1 * this.step)
      );
      this.add.addEventListener("click", () =>
        this.change_quantity(1 * this.step)
      );
    }
    connectedCallback() {
      this.classList.add("buttons_added");
      this.validateQtyRules();
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute("min") > quantity + change) {
        return;
      }
      if (this.input.getAttribute("max")) {
        if (this.input.getAttribute("max") < quantity + change) {
          return;
        }
      }
      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);

      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle("disabled", value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle("disabled", value >= max);
      }
    }
  }
  customElements.define("quantity-selector", QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {
  constructor(self) {
    this.submenu = self.parentNode.querySelector(".sub-menu");
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener("click", (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains("active")) {
      submenu.classList.add("active");
    } else {
      submenu.classList.remove("active");
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll(".thb-arrow");
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get("product-card")) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector(".product-card-swatches");
      this.colorSwatches = this.querySelectorAll("#product-card-swatches");
      this.restSwatches = new Array();
      this.image = this.querySelector(
        ".product-featured-image-link .product-primary-image"
      );
      this.additional_images = this.querySelectorAll(
        ".product-secondary-image"
      );
      this.additional_images_nav = this.querySelectorAll(
        ".product-secondary-images-nav li"
      );
      this.quick_add = this.querySelector(
        ".product-card--add-to-cart-button-simple"
      );
      this.size_options = this.querySelector(".product-card-sizes");
      this.plusButton = this?.querySelector(".plus-button");
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }

      if (this.additional_images) {
        this.enableAdditionalImages();
      }

      if (this.quick_add) {
        this.enableQuickAdd();
      }

      if (this.size_options) {
        this.enableSizeOptions();
      }

      if (this.colorSwatches) {
        this.hideShowSwatches();
      }

      if (this.plusButton) {
        this.plusButton.addEventListener("click", () => {
          this.showRestSwatches();
        });
      }
    }
    hideShowSwatches() {
      this.colorSwatches.forEach((swatch) => {
        if (
          swatch.dataset.maxswatchestoshow == 0 ||
          swatch.dataset.maxswatchestoshow >= this.colorSwatches.length
        ) {
          this.plusButton?.classList.add("hide");
          return;
        }
        if (swatch.dataset.forloop > swatch.dataset.maxswatchestoshow) {
          this.restSwatches.push(swatch);
        }
        this.restSwatches.forEach((swatch) => {
          swatch.classList.add("hide-swatch");
        });
      });
    }

    showRestSwatches() {
      this.colorSwatches.forEach((swatch) => {
        if (
          swatch.classList.contains("hide-swatch") &&
          !swatch.classList.contains("show-swatch")
        ) {
          swatch.classList.remove("hide-swatch");
          swatch.classList.add("show-swatch");
        } else if (
          swatch.classList.contains("show-swatch") &&
          !swatch.classList.contains("hide-swatches")
        ) {
          swatch.classList.add("hide-swatch");
          swatch.classList.remove("show-swatch");
        }
      });
    }

    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector(".product-featured-image");
      const mousemove = function (e) {
        if (
          !e.target.parentElement.classList.contains(
            "product-featured-image-link"
          )
        ) {
          return;
        }
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains("hover")) {
            image.classList.remove("hover");
            if (nav.length) {
              nav[index].classList.remove("active");
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains("hover")) {
            selimg.classList.add("hover");
            if (nav.length) {
              nav[sel].classList.add("active");
            }
          }
        }
      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove("hover");
          if (nav.length) {
            nav[index].classList.remove("active");
          }
        });
      };
      if (image_container) {
        image_container.addEventListener("touchstart", mousemove, {
          passive: true,
        });
        image_container.addEventListener("touchmove", mousemove, {
          passive: true,
        });
        image_container.addEventListener("touchend", mouseleave, {
          passive: true,
        });
        image_container.addEventListener("mouseenter", mousemove, {
          passive: true,
        });
        image_container.addEventListener("mousemove", mousemove, {
          passive: true,
        });
        image_container.addEventListener("mouseleave", mouseleave, {
          passive: true,
        });
      }

      images.forEach(function (image) {
        window.addEventListener("load", (event) => {
          lazySizes.loader.unveil(image);
        });
      });
    }
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll(".product-card-swatch"),
        org_srcset = image ? image.dataset.srcset : "";
      this.color_index = this.swatches.dataset.index;

      swatch_list.forEach((swatch, index) => {
        window.addEventListener("load", (event) => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });

        swatch.addEventListener("mouseover", () => {
          [].forEach.call(swatch_list, function (el) {
            el.classList.remove("active");
          });
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute("srcset", swatch.dataset.srcset);
            } else {
              image.setAttribute("srcset", org_srcset);
            }
          }
          if (this.size_options) {
            this.current_options[this.color_index] =
              swatch.querySelector("span").innerText;
            this.updateMasterId();
          }
          swatch.classList.add("active");
        });
        swatch.addEventListener("click", function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }
    enableQuickAdd() {
      this.quick_add.addEventListener("click", this.quickAdd.bind(this));
    }
    enableSizeOptions() {
      let size_list = this.size_options.querySelectorAll(
        ".product-card-sizes--size"
      ),
        featured_image = this.querySelector(".product-featured-image"),
        has_hover = featured_image.classList.contains("thb-hover"),
        size_parent = this.size_options.parentElement;

      this.size_index = this.size_options.dataset.index;

      this.current_options = this.size_options.dataset.options.split(",");

      this.updateMasterId();

      size_parent.addEventListener(
        "mouseenter",
        () => {
          if (has_hover) {
            featured_image.classList.remove("thb-hover");
          }
        },
        {
          passive: true,
        }
      );
      size_parent.addEventListener(
        "mouseleave",
        () => {
          if (has_hover) {
            featured_image.classList.add("thb-hover");
          }
        },
        {
          passive: true,
        }
      );
      size_list.forEach((size) => {
        size.addEventListener("click", (evt) => {
          evt.preventDefault();

          if (size.classList.contains("is-disabled")) {
            return;
          }
          this.current_options[this.size_index] =
            size.querySelector("span").innerText;
          this.updateMasterId();

          size.classList.add("loading");
          size.setAttribute("aria-disabled", true);
          const config = {
            method: "POST",
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              Accept: "application/javascript",
            },
          };
          let formData = new FormData();

          formData.append("id", this.currentVariant.id);
          formData.append("quantity", 1);
          formData.append(
            "sections",
            this.getSectionsToRender().map((section) => section.section)
          );
          formData.append("sections_url", window.location.pathname);

          config.body = formData;

          fetch(`${theme.routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                return;
              }
              this.renderContents(response);

              dispatchCustomEvent("cart:item-added", {
                product: response.hasOwnProperty("items")
                  ? response.items[0]
                  : response,
              });
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              size.classList.remove("loading");
              size.removeAttribute("aria-disabled");
            });
        });
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.current_options[index] === option;
          })
          .includes(false);
      });
      setTimeout(() => {
        this.setDisabled();
      }, 100);
    }
    getVariantData() {
      this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
    setDisabled() {
      const variant_data = this.getVariantData();

      if (variant_data) {
        if (this.currentVariant) {
          const selected_options = this.currentVariant.options.map(
            (value, index) => {
              return {
                value,
                index: `option${index + 1}`,
              };
            }
          );

          const available_options = this.createAvailableOptionsTree(
            variant_data,
            selected_options
          );

          const fieldset_options =
            Object.values(available_options)[this.size_index];
          if (fieldset_options) {
            if (
              this.size_options.querySelectorAll(".product-card-sizes--size")
                .length
            ) {
              this.size_options
                .querySelectorAll(".product-card-sizes--size")
                .forEach((input, input_i) => {
                  input.classList.toggle(
                    "is-disabled",
                    fieldset_options[input_i].isUnavailable
                  );
                });
            }
          }
        } else {
          if (
            this.size_options.querySelectorAll(".product-card-sizes--size")
              .length
          ) {
            this.size_options
              .querySelectorAll(".product-card-sizes--size")
              .forEach((input, input_i) => {
                input.classList.add("is-disabled");
              });
          }
        }
      }
      return true;
    }
    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce(
        (options, variant) => {
          // Check each option group (e.g. option1, option2, option3) of the variant
          Object.keys(options).forEach((index) => {
            if (variant[index] === null) return;

            let entry = options[index].find(
              (option) => option.value === variant[index]
            );

            if (typeof entry === "undefined") {
              // If option has yet to be added to the options tree, add it
              entry = {
                value: variant[index],
                isUnavailable: true,
              };
              options[index].push(entry);
            }

            // Check how many selected option values match a variant
            const countVariantOptionsThatMatchCurrent = selected_options.reduce(
              (count, { value, index }) => {
                return variant[index] === value ? count + 1 : count;
              },
              0
            );

            // Only enable an option if an available variant matches all but one current selected value
            if (
              countVariantOptionsThatMatchCurrent >=
              selected_options.length - 1
            ) {
              entry.isUnavailable =
                entry.isUnavailable && variant.available
                  ? false
                  : entry.isUnavailable;
            }

            // Make sure if a variant is unavailable, disable currently selected option
            if (
              (!this.currentVariant || !this.currentVariant.available) &&
              selected_options.find(
                (option) =>
                  option.value === entry.value && index === option.index
              )
            ) {
              entry.isUnavailable = true;
            }

            // First option is always enabled
            if (index === "option1") {
              entry.isUnavailable =
                entry.isUnavailable && variant.available
                  ? false
                  : entry.isUnavailable;
            }
          });

          return options;
        },
        {
          option1: [],
          option2: [],
          option3: [],
        }
      );
    }
    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add("loading");
      this.quick_add.setAttribute("aria-disabled", true);

      const config = {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/javascript",
        },
      };

      let formData = new FormData();

      formData.append("id", this.quick_add.dataset.productId);
      formData.append("quantity", 1);
      formData.append(
        "sections",
        this.getSectionsToRender().map((section) => section.section)
      );
      formData.append("sections_url", window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent("cart:item-added", {
            product: response.hasOwnProperty("items")
              ? response.items[0]
              : response,
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove("loading");
          this.quick_add.removeAttribute("aria-disabled");
        });

      return false;
    }
    getSectionsToRender() {
      return [
        {
          id: "Cart",
          section: "main-cart",
          selector: ".thb-cart-form",
        },
        {
          id: "Cart-Drawer",
          section: "cart-drawer",
          selector: ".cart-drawer",
        },
        {
          id: "cart-drawer-toggle",
          section: "cart-bubble",
          selector: ".thb-item-count",
        },
      ];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section) => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) ||
          document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
        if (typeof CartDrawer !== "undefined") {
          new CartDrawer();
        }
        if (typeof Cart !== "undefined") {
          new Cart().renderContents(parsedState);
        }
      });

      if (document.getElementById("Cart-Drawer")) {
        document.getElementById("Cart-Drawer").classList.add("active");
        document.body.classList.add("open-cart");
        document.body.classList.add("open-cc");
        if (
          document
            .getElementById("Cart-Drawer")
            .querySelector(".product-recommendations--full")
        ) {
          document
            .getElementById("Cart-Drawer")
            .querySelector(".product-recommendations--full")
            .classList.add("active");
        }
        dispatchCustomEvent("cart-drawer:open");
      }
    }
    getSectionInnerHTML(html, selector = ".shopify-section") {
      return new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define("product-card", ProductCard);
}
/**
 *  @class
 *  @function Header
 */
class Header {
  constructor() {
    const header = document.querySelector(".header-section"),
      header_main = document.getElementById("header"),
      menu = document.getElementById("mobile-menu"),
      toggle = document.querySelector(".mobile-toggle-wrapper"),
      setHeaderOffset = this.setHeaderOffset,
      setAnnouncementHeight = this.setAnnouncementHeight,
      setHeaderHeight = this.setHeaderHeight;

    if (!header_main) {
      return;
    }
    document.addEventListener("keyup", (e) => {
      if (e.code) {
        if (e.code.toUpperCase() === "ESCAPE") {
          toggle.removeAttribute("open");
          toggle.classList.remove("active");
        }
      }
    });
    toggle.querySelector(".mobile-toggle").addEventListener("click", (e) => {
      setAnnouncementHeight(header);
      if (toggle.classList.contains("active")) {
        e.preventDefault();
        document.body.classList.remove("overflow-hidden");
        toggle.classList.remove("active");
        this.closeAnimation(toggle);
      } else {
        document.body.classList.add("overflow-hidden");
        setTimeout(() => {
          toggle.classList.add("active");
        });
      }
      window.dispatchEvent(new Event("resize.resize-select"));
    });

    // Mobile Menu offset
    window.addEventListener(
      "scroll",
      function () {
        setHeaderOffset(header);
        setHeaderHeight(header_main);
        // Sticky Header Class
        if (header_main.classList.contains("header-sticky--active")) {
          let offset =
            parseInt(header_main.getBoundingClientRect().top, 10) +
            document.documentElement.scrollTop;

          header_main.classList.toggle(
            "is-sticky",
            window.scrollY >= offset && window.scrollY > 0
          );
        }
      },
      {
        passive: true,
      }
    );
    window.dispatchEvent(new Event("scroll"));

    if (document.getElementById("shopify-section-announcement-bar")) {
      const a_bar = document.getElementById("shopify-section-announcement-bar");
      window.addEventListener(
        "resize",
        function () {
          setAnnouncementHeight(a_bar);
        },
        {
          passive: true,
        }
      );
      window.dispatchEvent(new Event("resize"));
    }
    // Buttons.
    menu
      .querySelectorAll("summary")
      .forEach((summary) =>
        summary.addEventListener("click", this.onSummaryClick.bind(this))
      );
    menu
      .querySelectorAll("button")
      .forEach((button) =>
        button.addEventListener("click", this.onCloseButtonClick.bind(this))
      );
  }
  setAnnouncementHeight(a_bar) {
    let h = a_bar.clientHeight;
    document.documentElement.style.setProperty(
      "--announcement-height",
      h + "px"
    );
  }
  setHeaderOffset(header) {
    let h = header.getBoundingClientRect().top;
    document.documentElement.style.setProperty("--header-offset", h + "px");
  }
  setHeaderHeight(header) {
    let h = header.clientHeight;
    document.documentElement.style.setProperty("--header-height", h + "px");
  }
  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".link-container");
    const isOpen = detailsElement.hasAttribute("open");

    setTimeout(() => {
      detailsElement.classList.add("menu-opening");
      parentMenuElement && parentMenuElement.classList.add("submenu-open");
    }, 100);
  }
  onCloseButtonClick(event) {
    event.preventDefault();
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }
  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    this.closeAnimation(detailsElement);
  }
  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        detailsElement.querySelectorAll("details").forEach((details) => {
          details.removeAttribute("open");
          details.classList.remove("menu-opening");
          details.classList.remove("submenu-open");
        });
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}
/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get("full-menu")) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.submenus = this.querySelectorAll(
        ".thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu"
      );

      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      window.addEventListener(
        "resize",
        debounce(function () {
          _this.resizeSubMenus();
        }, 100)
      );

      window.dispatchEvent(new Event("resize"));

      document.fonts.ready.then(function () {
        _this.resizeSubMenus();
      });
    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(
          ":scope >.menu-item-has-children>.sub-menu"
        );

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l =
              sub_submenu.parentElement.parentElement.getBoundingClientRect()
                .left +
              sub_submenu.parentElement.parentElement.clientWidth +
              10,
            total = w + l;
          if (total > document.body.clientWidth) {
            sub_submenu.parentElement.classList.add("left-submenu");
          } else if (
            sub_submenu.parentElement.classList.contains("left-submenu")
          ) {
            sub_submenu.parentElement.classList.remove("left-submenu");
          }
        });
      });
    }
  }
  customElements.define("full-menu", FullMenu);
}
/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get("side-panel-close")) {
  class PanelClose extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector(".click-capture");

      this.onClick = (e) => {
        // document.body.classList.remove("overflow-hidden-cart")
        let panel = document.querySelectorAll(".side-panel.active");
        if (panel.length) {
          this.close_panel(e, panel[0]);
        }
      };
      // Add functionality to buttons
      this.addEventListener("click", this.onClick.bind(this));
      document.addEventListener("panel:close", this.onClick.bind(this));
      if (!this.cc.hasAttribute("initialized")) {
        this.cc.addEventListener("click", this.onClick.bind(this));
        this.cc.setAttribute("initialized", "");
      }
    }
    close_panel(e, panel) {
      if (e) {
        e.preventDefault();
      }
      if (!panel) {
        panel = e?.target.closest(".side-panel.active");

        if (!panel) {
          return;
        }
      }
      if (
        panel.classList.contains("product-drawer") ||
        document.body.classList.contains("open-quick-view")
      ) {
        this.close_quick_view();
      } else if (panel.classList.contains("cart-drawer")) {
        if (panel.querySelector(".product-recommendations--full")) {
          if (!document.body.classList.contains("open-quick-view")) {
            panel
              .querySelector(".product-recommendations--full")
              .classList.remove("active");
          }
        }
        if (window.innerWidth < 1069) {
          if (!document.body.classList.contains("open-quick-view")) {
            panel.classList.remove("active");
            document.body.classList.remove("open-cc");
            document.body.classList.remove("open-cart");
          } else {
            this.close_quick_view();
          }
        } else {
          if (panel.querySelector(".product-recommendations--full")) {
            if (!document.body.classList.contains("open-quick-view")) {
              setTimeout(() => {
                panel.classList.remove("active");
                document.body.classList.remove("open-cc");
                document.body.classList.remove("open-cart");
              }, 500);
            } else {
              this.close_quick_view();
            }
          } else {
            panel.classList.remove("active");
            document.body.classList.remove("open-cc");
            document.body.classList.remove("open-cart");
          }
        }
      } else {
        panel.classList.remove("active");
        document.body.classList.remove("open-cc");
      }
    }
    close_quick_view() {
      let panel = document.getElementById("Product-Drawer");

      if (panel.querySelector(".product-quick-images--container")) {
        panel
          .querySelector(".product-quick-images--container")
          .classList.remove("active");
      }
      if (window.innerWidth < 1069) {
        panel.classList.remove("active");
        if (
          !document.body.classList.contains("open-cart") ||
          !document.body.classList.contains("open-quick-view")
        ) {
          document.body.classList.remove("open-cc");
        }
        document.body.classList.remove("open-quick-view");
      } else {
        if (panel.querySelector(".product-quick-images--container")) {
          setTimeout(() => {
            panel.classList.remove("active");
            if (
              !document.body.classList.contains("open-cart") ||
              !document.body.classList.contains("open-quick-view")
            ) {
              document.body.classList.remove("open-cc");
            }
            document.body.classList.remove("open-quick-view");
            panel.querySelector("#Product-Drawer-Content").innerHTML = "";
          }, 500);
        }
      }
    }
  }
  customElements.define("side-panel-close", PanelClose);

  document.addEventListener("keyup", (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === "ESCAPE") {
        dispatchCustomEvent("panel:close");
      }
    }
  });
}
/**
 *  @class
 *  @function CartDrawer
 */
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {

    constructor() {
      super();
      this.firstRender();
      document.addEventListener('cart:item-added', ()=>{
        this.removeProductEvent();
        this.moveTowishListModal();
        this.cartfreebieAtc();
      })
      this.moveTowishListModal();
      this.cartfreebieAtc();
    }

    connectedCallback() {
      let button = document.getElementById('cart-drawer-toggle');

      if (!button) {
        return;
      }

      // Add functionality to buttons
      button.addEventListener('click', (e) => {
        e.preventDefault();
        document.body.classList.add('open-cc');
        document.body.classList.add('open-cart');
        this.classList.add('active');
        this.focus();
        setTimeout(() => {
          this.querySelector('.product-recommendations--full')?.classList.add('active');
        });
        dispatchCustomEvent('cart-drawer:open');
      });

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      document.addEventListener('cart:refresh', (event) => {
        this.refresh();
      });

      document.addEventListener('cart:item-added',()=>{
        this.refreshAddonCheckbox();
      })

      document.addEventListener('line-item:change:end', ()=>{
        this.refreshAddonCheckbox();
      });

      this.addEventListener('change', this.debouncedOnChange.bind(this));

      this.notesToggle();
      this.removeProductEvent();
      this.moveTowishListModal();
      this.cartfreebieAtc();
    }
    onChange(event) {
      if (event.target.classList.contains('qty')) {
        this.updateQuantity(event.target.dataset.index, event.target.value);
      }
    }
    removeProductEvent() {  
      let removes = this.querySelectorAll('.remove');

      removes.forEach((remove) => {
        remove.addEventListener('click', (event) => {
          this.updateQuantity(event.target.dataset.index, '0');

          event.preventDefault();
        });
      });
    }

    refreshAddonCheckbox() {
      
      fetch(window.location.pathname)
        .then(res => res.text())
        .then(html => {
          const newDom = new DOMParser().parseFromString(html, 'text/html');

          const newWrapper = newDom.querySelector('#freebie-wrapper');
          const currentWrapper = document.querySelector('#freebie-wrapper');

          if (newWrapper && currentWrapper) {
            currentWrapper.replaceWith(newWrapper);
          }

        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    notesToggle() {
      const notes_toggle = document.getElementById('order-note-toggle');

      if (!notes_toggle) {
        return;
      }

      notes_toggle.addEventListener('click', (event) => {
        notes_toggle.nextElementSibling.classList.add('active');
      });
      notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
        el.addEventListener('click', (event) => {
          notes_toggle.nextElementSibling.classList.remove('active');
          this.saveNotes();
        });
      });
    }
    saveNotes() {
      fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        body: JSON.stringify({
          'note': document.getElementById('mini-cart__notes').value
        })
      });
    }
    updateQuantity(line, quantity) {      
      this.querySelector(`#CartDrawerItem-${line}`)?.classList.add('thb-loading');
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      dispatchCustomEvent('line-item:change:start', {
        quantity: quantity
      });
      this.querySelector('.product-recommendations--full')?.classList.remove('active');

      fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            if (parsedState.sections) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }));

          this.firstRender();
          this.removeProductEvent();
          this.moveTowishListModal();
          this.notesToggle();
          this.cartfreebieAtc();
          dispatchCustomEvent('line-item:change:end', {
            quantity: quantity,
            cart: parsedState
          });

          this.querySelector(`#CartDrawerItem-${line}`)?.classList.remove('thb-loading');
        });
    }
    refresh() {
      this.querySelector('.product-recommendations--full')?.classList.remove('active');
      let sections = 'cart-drawer,cart-bubble';
      fetch(`${window.location.pathname}?sections=${sections}`)
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
          }));

          this.firstRender();
          this.removeProductEvent();
          this.notesToggle();
          this.moveTowishListModal();
          this.cartfreebieAtc();
        });
    }

      // FUNCTION TO DO SECTION RENDERING FOR THE FIRST LOAD OF WEBSITE
    firstRender() {
      let oldContent = document
        .getElementById("Cart-Drawer")
        .querySelector(".offers-wrapper");
      const sectionId = "cart-drawer";
      fetch(`${window.location.pathname}?sectionId=${sectionId}`)
        .then((response) => response.text())
        .then((html) => {
          try {
            const parser = new DOMParser();
            const parsedHTML = parser.parseFromString(html, "text/html");
            const newContent = parsedHTML.querySelector(".offers-wrapper");
            if (newContent && oldContent) {
              oldContent.innerHTML = newContent.innerHTML;
            }
            // this.removeProductEvent();
            // this.notesToggle();
          } catch (error) {
            console.error("Error parsing HTML:", error);
          }
        })
        .catch((error) => {
          console.error("Fetch error:", error);
        });
    }

      removeFreebieIfExists() {
        
        const FREEBIE_VARIANT_ID = '51579160723743';

        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: FREEBIE_VARIANT_ID,
            quantity: 0
          })
        }).then(() => {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('line-item:change:end'));
        }).catch(err => console.error('Failed to remove freebie', err));
      }

      cartfreebieAtc() {
        const freebieAtcButton = this.querySelector('.cart_atc-button');
        const atcText = freebieAtcButton?.querySelector('.atc-text');
        const atcLoader = freebieAtcButton?.querySelector('.loading-overlay');

        if (freebieAtcButton) {
          const freebieProductId = Number(freebieAtcButton.dataset.variantId);
          
          freebieAtcButton.addEventListener('click', () => {
            if(atcText) atcText.style.display = 'none';
            if(atcLoader) atcLoader.style.display = 'block';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              id: freebieProductId,
              quantity: 1
            })
          })
            .then(res => res.json())
            .then(() => {
              if(atcText) atcText.style.display = 'block';
              if(atcLoader) atcLoader.style.display = 'none';
              // Refresh cart UI
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              document.dispatchEvent(new CustomEvent('cart:item-added'));
            })
            .catch(err => console.error('Freebie ATC failed', err));
          });
        }
      }




    moveTowishListModal() {
       
      
       
      this.cartRemoveButtons = this.querySelectorAll('.cart_remove-button');

      this.cartRemoveButtons.forEach((cartRemoveButton) => {

        // Target elements
        const cart_modalRemoveWrapper = cartRemoveButton.querySelector('.cart_modalRemove');
        const closeBtn = cart_modalRemoveWrapper.querySelector('.cart_closeModal');
        const removeProductButton = cart_modalRemoveWrapper.querySelector('.remove-button');
        const wishlistButton = cart_modalRemoveWrapper.querySelector('.add-wishlist-button');
        const wishlistText = wishlistButton.querySelector('.wishlist-text');
        const wishlistLoader = wishlistButton.querySelector('.cart_loader-wrapper');

        // Identify line-item index from the parent button
        const lineIndex = removeProductButton.dataset.index;
        

        // Open modal
        cartRemoveButton.addEventListener('click', (e) => {
          e.stopPropagation();
          cart_modalRemoveWrapper.classList.remove('hidden');
        });

        // Close modal
        closeBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          cart_modalRemoveWrapper.classList.add('hidden');
        });

        // REMOVE PRODUCT (same as removeProductEvent)
        if (removeProductButton) {
          removeProductButton.addEventListener('click', (e) => {
            e.stopPropagation();
            e.preventDefault();

            const lineIndex = removeProductButton.dataset.index;
            // const removedVariantId = Number(removeProductButton.dataset.variantId);
            const hasFreebie = removeProductButton.dataset.hasFreebie === 'true';
            const hasDiscount = removeProductButton.dataset.discount === 'true';

            // const FREEBIE_VARIANT_ID = 51579160723743;

            // 🔍 Check if ANY other cart item still has has_freebie="true"
            const anotherFreebieEligibleItemExists = Array.from(
            this.querySelectorAll('.remove-button')
            ).some(btn =>
              btn !== removeProductButton &&      // 👈 exclude current item
              btn.dataset.hasFreebie === 'true'
            );

            // Always remove the clicked item
            this.updateQuantity(lineIndex, '0');
            cart_modalRemoveWrapper.classList.add('hidden');

            // Only proceed if:
            // 1. Removed item is NOT the freebie
            // 2. Item has has_freebie="true"
            // 3. Item has discount="true"
            if (hasFreebie && hasDiscount && !anotherFreebieEligibleItemExists) {
              setTimeout(() => {
                this.removeFreebieIfExists();
              }, 400);
            }
          });
        }



        // Event added to redirect the page to the wishlist.
        wishlistButton.addEventListener('click', () => {
        //  document.dispatchEvent(new CustomEvent("line-item:change:end"));
          // Hide text
          wishlistText.classList.add('hidden');

          // Show loader
          wishlistLoader.classList.remove('hidden');
          // setTimeout(() => {
          //   window.location.href = '/apps/wishlist';
          // }, 3000);
            document
            .querySelectorAll('.cart_modalRemove .add-wishlist-button')
            .forEach((btn) => {
              btn.dataset.wishlistFlag = 'true';
            });
        })

      });
      if(typeof __this != 'undefined'){
        __this._cartPageAction();
      }
    }
  }
  customElements.define('cart-drawer', CartDrawer);
}


document.addEventListener('DOMContentLoaded',()=>{
  window.fetchAndRenderCartCrossSell();
})

class CustomProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.parent = this.closest('.product-recommendations--parent');
  }

  connectedCallback(){
    this.openPanel();
  }

  openPanel() {
    if (this.parent) {
      this.parent.classList.add('product-recommendations--full');

      if (document.body.classList.contains('open-cart')) {
        this.parent.classList.add('active');
      }
    }
  }

}

customElements.define('custom-product-recommendations', CustomProductRecommendations);




/**
 *  @class
 *  @function ModalDialog
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") {
        this.hide();
      }
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    const modal = document.querySelector('.product-popup-modal');
    modal.addEventListener('animationend', () => {
      const modalContent = modal.querySelector('.product-popup-modal__content');
      if (modalContent) {
        modalContent.scrollTop = 0;
      }
    });

    checkVariantQuantityInCart(selectedSizeForSizeChart);
    this.setAttribute('open', '');
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    this.querySelectorAll(".js-youtube").forEach((video) => {
      video.contentWindow.postMessage(
        '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
        "*"
      );
    });
    this.querySelectorAll(".js-vimeo").forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', "*");
    });
    this.querySelectorAll("video").forEach((video) => video.pause());
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

/**
 *  @class
 *  @function Localization
 */
class Localization {
  constructor() {
    let _this = this;
    // resize on initial load
    document
      .querySelectorAll(".thb-localization-forms")
      .forEach((localization) => {
        localization.addEventListener("change", (e) => {
          localization.querySelector("form").submit();
        });
      });
  }
}

/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    window.addEventListener("load", () => {
      document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);
    });

    // delegated listener on change
    document.body.addEventListener("change", (e) => {
      if (
        e.target.matches(".resize-select") &&
        e.target.offsetParent !== null
      ) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener("resize.resize-select", function () {
      document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement("option");
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement("select"),
      offset = 13;
    tempSelect.style.visibility = "hidden";
    tempSelect.style.position = "fixed";
    tempSelect.appendChild(tempOption);
    if (
      sel.classList.contains("thb-language-code") ||
      sel.classList.contains("thb-currency-code") ||
      sel.classList.contains("facet-filters__sort")
    ) {
      offset = 2;
    }
    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + offset}px`;
    }
    tempSelect.remove();
  }
}

if (typeof SelectWidth !== "undefined") {
  new SelectWidth();
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document
      .querySelectorAll(".thb-widget-title.collapsible")
      .forEach((button) => {
        button.addEventListener("click", (e) => {
          button.classList.toggle("active");
        });
      });
  }
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get("quick-view")) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.drawer = document.getElementById("Product-Drawer");
      this.body = document.body;

      this.addEventListener("click", this.setupEventListener.bind(this));
    }
    setupEventListener(e, handle) {
      e.preventDefault();
      // document.body.classList.add("overflow-hidden-cart")

      let href;
      const productHandle =
        handle || this.dataset.activeProduct || this.dataset.productHandle;
      href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace("//", "/");
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains("loading")) {
        return;
      }
      this.classList.add("loading");
      fetch(href, {
        method: "GET",
      })
        .then((response) => {
          this.classList.remove("loading");
          return response.text();
        })
        .then((text) => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector("#Product-Drawer-Content").innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);
        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {
        this.drawer.querySelector("#Product-Drawer-Content").innerHTML =
          sectionInnerHTML;

        let js_files = this.drawer
          .querySelector("#Product-Drawer-Content")
          .querySelectorAll("script");

        if (js_files.length > 0) {
          var head = document.getElementsByTagName("head")[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement("script");
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        this.body.classList.add("open-cc");
        this.body.classList.add("open-quick-view");
        this.drawer.classList.add("active");

        this.drawer.querySelector(".side-panel-close").focus();

        setTimeout(() => {
          this.drawer
            .querySelector(".product-quick-images--container")
            .classList.add("active");
        });
        dispatchCustomEvent("quick-view:open", {
          productUrl: href,
          productHandle: productHandle,
        });
        addIdToRecentlyViewed(productHandle);
      }
    }
  }
  customElements.define("quick-view", QuickView);
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get("side-panel-content-tabs")) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll("button");
      this.panels = this.parentElement.querySelectorAll(
        ".side-panel-content--tab-panel"
      );
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() { }
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener("click", (e) => {
          this.toggleActiveClass(i);
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove("tab-active");
      });
      this.buttons[i].classList.add("tab-active");

      this.panels.forEach((panel) => {
        panel.classList.remove("tab-active");
      });
      this.panels[i].classList.add("tab-active");
    }
  }

  customElements.define("side-panel-content-tabs", SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get("collapsible-row")) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector("details");
      this.summary = this.querySelector("summary");
      this.content = this.querySelector(".collapsible__content");

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      this.querySelector("summary").addEventListener("click", (e) =>
        this.onClick(e)
      );
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = "hidden";
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate(
        {
          // Set the keyframes from the startHeight to endHeight
          height: [startHeight, endHeight],
        },
        {
          duration: 250,
          easing: "ease",
        }
      );

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => (this.isClosing = false);
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      let endHeight;
      if (this.content && this.content.offsetHeight) {
        endHeight = `${this.summary.offsetHeight + this.content.offsetHeight
          }px`;
      }
      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate(
        {
          // Set the keyframes from the startHeight to endHeight
          height: [startHeight, endHeight],
        },
        {
          duration: 400,
          easing: "ease-out",
        }
      );
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => (this.isExpanding = false);
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = "";
    }
  }
  customElements.define("collapsible-row", CollapsibleRow);
}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {
  if (!handle) {
    let product = document.querySelector(".thb-product-detail");

    if (product) {
      handle = product.dataset.handle;

      if (!handle) {
        return;
      }
    }
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem("recently-viewed");
    if (recentIds && typeof recentIds !== undefined) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem(
      "recently-viewed",
      JSON.stringify(window.recentlyViewedIds)
    );
  }
}

document.addEventListener("DOMContentLoaded", () => {
  if (typeof Localization !== "undefined") {
    new Localization();
  }
  if (typeof CartDrawer !== "undefined") {
    new CartDrawer();
  }
  if (typeof Header !== "undefined") {
    new Header();
  }
  if (typeof FooterMenuToggle !== "undefined") {
    new FooterMenuToggle();
  }
});

// This function handles the size selection and saves it to localStorage
document.addEventListener("change", (event) => {
  if (event.target.name === "Size" || event.target.name === "Size--sticky") {
    const selectedSize = event.target.value;
    localStorage.setItem("selectedSize", selectedSize);
  }
});

// This is the code for the product-option-color
// On click of color options, it will fetch the variant URL and update the sections
let selectedSize = "";
if (!customElements.get("product-option-color")) {
  class ProductOptionColor extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("click", this.onColorClick);
    }

    getSectionsToRender() {
      return [".main-product-section", ".product-popup-modal__content-info"];
    }

    updateURL() {
      if (!this.variantUrl || this.dataset.updateUrl === "false") return;
      // window.history.replaceState({}, "", `${this.variantUrl}`);
    }

    async onColorClick(e) {
      // If the color is already selected, then return
      if (this.classList.contains('selected')) return;

      //find the selected size
      document.querySelectorAll('[name="Size"]').forEach(function (checkbox) {
        if (checkbox.checked) {
          selectedSize = checkbox.value;
        }
      });

      if (this.closest('#Product-Drawer')) {
        const productHandle = this.dataset.productHandle;
        document.querySelector('quick-view').setupEventListener(e, productHandle);
        return;
      }

      const sections = this.getSectionsToRender();
      const sectionId = this.dataset.sectionId;
      this.variantUrl = this.dataset.variantUrl;
      let url = `${this.variantUrl}&section_id=${sectionId}`;
      showLoader();
      try {
        const response = await fetch(url);
        const data = await response.text();
        const parser = new DOMParser();
        const html = parser.parseFromString(data, 'text/html');

        // Update the sections
        sections.forEach((section) => {
          const source = html.querySelector(section);
          const destination = document.querySelector(section);
          if (source && destination) {
            destination.innerHTML = source.innerHTML;
          }
          if (document.querySelector(".product-popup-modal__content-info")) {
            productVariants = getVariantData();
            firstAvailableVariant = getFirstAvailableVariant();
          }
        });
        if (document.querySelector('.product-popup-modal__content-info')) {
          reAttachEventListeners();
        }
        document.querySelectorAll('[name="Size"]').forEach((checkbox) => {
          if (checkbox.value === selectedSize) {
            checkbox.checked = true;
            if (document.querySelector('.product-popup-modal__content-info')) {
              centralVariantChangeHandler(selectedSize);
            }

            document.querySelector('.variant-selects').onVariantChange();
          }
        });
        document.querySelectorAll('.measurement-units')?.forEach((button) => {
          button.addEventListener('click', (e) => {
            handleTabClick(e.target);
          })
        })
        hideLoader();
        // Update the URL
        this.updateURL();
        const offersButton = document.querySelector('.offers-wrapper-pdp');
        if (offersButton) {
          offersButton.addEventListener('click', (event) => {
            event.stopPropagation();
            showPopup();
            copyPDPOffers();
          });
        }
        document.querySelector('.close-popup').addEventListener('click', (event) => {
          event.stopPropagation();
          closePopup();
        });

      } catch (error) {
        console.error('Error:', error);
        window.location.href = variantUrl; // Fallback to the variant URL
      } finally {
        if (e.target.matches('product-add-to-cart-sticky product-option-color')) {
          document.querySelector('product-add-to-cart-sticky button').click(); // This will open the sticky add to cart
        }
        // HulkappWishlist.init();
        Shopify.PaymentButton.init();
        document.querySelector(`[value="${selectedSize}"]`).click();
        if (window.innerHeight < 1024) {
          document.querySelector('.main-product-section').scrollIntoView({
            behavior: "smooth",
            block: "start"
          })
        }

      }

    }
  }

  customElements.define("product-option-color", ProductOptionColor);
}

function showLoader() {
  const body = document.querySelector("body");
  const wrapper = document.createElement("div");
  wrapper.classList.add("loader-wrapper");
  wrapper.innerHTML = `<div class="loader"></div>`;
  body.appendChild(wrapper);
}

function hideLoader() {
  const wrapper = document.querySelector(".loader-wrapper");
  wrapper && wrapper.remove();
}

// set the overflow scroll bar postion based on the active tab of the customer service pages
const tabContainerEl = document.querySelector(
  ".customer-service-page-nav-link-container"
);
const activeTab = document.querySelector(
  ".customer-service-page-nav-link-container li a.active-customer-nav-link"
);
if (activeTab) {
  const containerWidth = tabContainerEl.offsetWidth;
  const activeTabWidth = activeTab.offsetWidth;
  const containerLeft = tabContainerEl.getBoundingClientRect().left;
  const activeTabRect = activeTab.getBoundingClientRect();
  const scrollLeft =
    activeTabRect.left -
    containerLeft -
    containerWidth / 2 +
    activeTabWidth / 2;
  tabContainerEl.scrollTo({
    left: scrollLeft,
    behavior: "smooth",
  });
}

// Signup Consent Checkbox
document.addEventListener("DOMContentLoaded", () => {
  const registerButton = document.querySelector(".register-button");
  const mandatoryFields = document.querySelectorAll(".mandatory-field");
  const registerFirstName = document.querySelector('.register-firstName');
  const registerLastName = document.querySelector('.register-lastName');
  const editPageInputs = document.querySelectorAll('form.caeForm .field input');
  const editPageSubmitbtn = document.querySelector('form.caeForm #submit_button');

  const checkMandatoryFields = () => {
    let allChecked = true;

    mandatoryFields.forEach((field) => {
      if (!field.checked) {
        allChecked = false;
      }
    });

    if (allChecked) {
      registerButton.removeAttribute("disabled");
    } else {
      registerButton.setAttribute("disabled", "true");
    }
  };

  //disabling the submit button if the first name and last name is not filled
  if (registerFirstName && registerLastName && registerButton) {
    // Disable the button initially if both fields are empty
    if (registerFirstName.value.trim() === '' && registerLastName.value.trim() === '') {
      registerButton.setAttribute("disabled", "true");
    }

    function checkInputs() {
      if (registerFirstName.value.trim() !== '' && registerLastName.value.trim() !== '') {
        registerButton.removeAttribute("disabled");
      } else {
        registerButton.setAttribute("disabled", "true");
      }
    }

    // Add event listeners only if elements exist
    registerFirstName.addEventListener('input', checkInputs);
    registerLastName.addEventListener('input', checkInputs);
  }

  if (editPageInputs) {
    editPageInputs.forEach((editPageInput) => {
      editPageInput.addEventListener('input', () => {
        const allFilled = Array.from(editPageInputs).every(input => input.value.trim() !== '');
        if (allFilled) {
          editPageSubmitbtn.removeAttribute("disabled");
        } else {
          editPageSubmitbtn.setAttribute("disabled", "true");
        }
      });
    });
  }

  // Add event listeners to each mandatory field to listen for changes
  mandatoryFields.forEach((field) => {
    field.addEventListener("change", checkMandatoryFields);
  });
});

// Cart Offers.
function showCouponsList() {
  document.querySelector(".offers-section").classList.add("active");
  document
    .querySelector(".main-cart-drawer-wrapper")
    .classList.add("in-active");
  document.querySelector(".offer-button-wrapper").classList.add("in-active");
  document.querySelector(".offer-button-close").classList.add("active");
}

function hideCouponsList() {
  document
    .querySelector(".main-cart-drawer-wrapper")
    .classList.remove("in-active");
  document.querySelector(".offers-section").classList.remove("active");
  document.querySelector(".offer-button-wrapper").classList.remove("in-active");
  document.querySelector(".offer-button-close").classList.remove("active");
}

// HANDLING THE EVENT LISTENERS ON COUPON CODE BUTTONS AND SHOWING THE SUCCESS/ERROR MESSAGE.
function handleCouponButtonClick(button, messageSelector) {
  button.addEventListener("click", function () {
    const copyButtonText = this.textContent.trim();
    if (copyButtonText) {
      navigator.clipboard
        .writeText(copyButtonText)
        .then(() => {
          document.querySelectorAll(messageSelector).forEach((text) => {
            text.classList.add("active");
            text.classList.remove("error-text");
            text.querySelector(".message").textContent =
              "Successfully copied the coupon code! Kindly paste the code during checkout to apply";

            const offersSection = document.querySelector(".offers-section");
            const activeElement = offersSection.querySelector(".active");
            if (activeElement) {
              activeElement.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }
          });
        })
        .catch((err) => {
          document.querySelectorAll(messageSelector).forEach((text) => {
            text.classList.add("active");
            text.classList.add("error-text");
            text.querySelector(".message").textContent = "Failed to Copy!";
            window.scroll({
              top: 0,
              left: 0,
              behavior: "smooth",
            });
          });
        });
    } else {
      alert("No Text Found!");
    }
  });
}

function attachCouponButtonListeners() {
  const copyButtons = document.querySelectorAll(".coupon-button");
  const copyButtonsDrawer = document.querySelectorAll(
    ".coupon-button-cart-drawer"
  );

  const allCopyButtons = [...copyButtons, ...copyButtonsDrawer];

  allCopyButtons.forEach((button) => {
    // Check if the event listener has already been attached
    if (!button.hasAttribute("data-listener-attached")) {
      // Attach the respective event listener based on button type
      if (button.classList.contains("coupon-button-cart-drawer")) {
        handleCouponButtonClick(button, ".message-text");
      } else if (button.classList.contains("coupon-button")) {
        handleCouponButtonClick(button, ".message-text-cart");
      }

      // Mark the button as having an event listener attached
      button.setAttribute("data-listener-attached", "true");
    }
  });
}

// Call the function to attach listeners on page load or dynamically after content changes
attachCouponButtonListeners();

// Set up a MutationObserver to detect when new elements are added to the DOM
const observer = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
      // Reattach listeners whenever new nodes are added
      attachCouponButtonListeners();
    }
  }
});

// Set the observer target to look for new changes.
const observerTarget = document.querySelector(".cart-drawer");
observer.observe(observerTarget, { childList: true, subtree: true });

const messageText = document.querySelector(".message-text");
const messageCloseButton = document.querySelector(".message-close");
if (messageCloseButton) {
  messageCloseButton.addEventListener("click", () => {
    messageText.classList.remove("active");
  });
}

// Download Button For Legal Page
var downloadLinks = document.querySelectorAll(".downloadLink");
if (downloadLinks) {
  downloadLinks.forEach((link) => {
    link.addEventListener("click", function (event) {
      event.preventDefault();
      const fullUrl = this.getAttribute("href");
      const urlWithoutQueryString = fullUrl.split("?")[0]; // Split by '?' and take the first part
      const filename = urlWithoutQueryString.substring(
        urlWithoutQueryString.lastIndexOf("/") + 1
      );

      fetch(fullUrl)
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => console.error("Error downloading file:", error));
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const wrapper = document.querySelector(".recaptcha-wrapper");
  wrapper.addEventListener("click", (event) => {
    event.stopPropagation();
    wrapper.classList.toggle("active");
  });
  document.addEventListener("click", (event) => {
    if (!wrapper.contains(event.target)) {
      wrapper.classList.remove("active");
    }
  });
});

// SIZE CHART REVAMP
let selectedSizeForSizeChart = "";
if (document.querySelector(".product-popup-modal__content-info")) {
  function getFirstAvailableVariant() {
    let variantData = JSON.parse(
      document
        .querySelector(".size-chart-wrapper")
        .querySelector(".first-variant").textContent
    );
    return variantData.id;
  }
  firstAvailableVariant = getFirstAvailableVariant();

  const currentUrl = new URL(window.location.href);
  const currentVariantInUrl =
    currentUrl.searchParams.get("variant") || firstAvailableVariant;
  const sizeChartButton = document.querySelector(".size-chart");
  let isSyncing = false;
  let debounceTimer;
  sizeChartButton.classList.add("active");
  if (document.querySelectorAll(".measurement-units")) {
    document.querySelectorAll(".measurement-units").forEach((button) => {
      button.addEventListener("click", () => {
        handleTabClick(button);
      });
    });
  }

  function handleTabClick(button) {
    document.querySelectorAll(".measurement-units").forEach((btn) => {
      btn.classList.remove("active");
    });
    document
      .querySelectorAll(".table-wrapper")
      .forEach((table) => table.classList.remove("active"));
    button.classList.add("active");
    const rows = document.querySelectorAll(".selectable-row");
    rows.forEach((row) => row.classList.remove("active"));

    if (button.classList.contains("in")) {
      document
        .querySelector(".table-wrapper.table-wrapper-inches")
        .classList.add("active");
      initializeRowSelection();
      handleScrollforTabs("in");
      checkVariantQuantityInCart(selectedSizeForSizeChart);
    } else {
      document
        .querySelector(".table-wrapper.table-wrapper-cm")
        .classList.add("active");
      initializeRowSelection();
      handleScrollforTabs("cm");
      checkVariantQuantityInCart(selectedSizeForSizeChart);
    }
    syncActiveState();
  }

  function handleScrollforTabs(unit) {
    const tabButtons = document.querySelectorAll(".size-chart-tab-buttons");
    const howToMeasureDiv = document.querySelector(".how-to-measure-wrapper");
    const howToMeasureButton = document.querySelector(".how-to-measure");
    const sizeChartButton = document.querySelector(".size-chart");
    const tabButtonsUnits = document.querySelectorAll(".measurement-units");
    const tables = document.querySelectorAll(".table-wrapper");
    const sizeChartTableInches = document.querySelector(
      ".table-wrapper-inches"
    );
    const sizeChartTableCm = document.querySelector(".table-wrapper-cm");
    const sizeChartWrapper = document.querySelector(".size-chart-wrapper");

    let isScrolling = false;
    let activeUnit = unit;

    if (tabButtons) {
      tabButtons.forEach((button) => {
        button.addEventListener("click", () => {
          isScrolling = true;
          tabButtons.forEach((btn) => btn.classList.remove("active"));
          button.classList.add("active");

          if (button.classList.contains("how-to-measure")) {
            howToMeasureDiv.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          } else if (button.classList.contains("size-chart")) {
            if (activeUnit === "in") {
              sizeChartWrapper.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            } else {
              sizeChartWrapper.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }
          }

          setTimeout(() => {
            isScrolling = false;
          }, 300);
        });
      });

      sizeChartButton?.classList.add("active");
    }

    // Intersection Observer for tab switching based on scroll
    const observerCallback = (entries) => {
      if (!isScrolling) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            tabButtons.forEach((btn) => btn.classList.remove("active"));

            if (entry.target === howToMeasureDiv) {
              howToMeasureButton.classList.add("active");
            }
            if (
              entry.target === sizeChartTableInches ||
              entry.target === sizeChartTableCm
            ) {
              sizeChartButton.classList.add("active");
            }
          }
        });
      }
    };

    const getObserverOptions = () => ({
      threshold: window.innerWidth < 768 ? 0.9 : 0.7,
    });

    const observerOptions = getObserverOptions();
    const observer = new IntersectionObserver(
      observerCallback,
      observerOptions
    );

    observer.observe(howToMeasureDiv);
    if (activeUnit === "in") {
      observer.observe(sizeChartTableInches);
    } else {
      observer.observe(sizeChartTableCm);
    }

    // Switch between inches and cm tables
    tabButtonsUnits.forEach((button) => {
      button.addEventListener("click", () => {
        tabButtonsUnits.forEach((btn) => btn.classList.remove("active"));
        tables.forEach((table) => table.classList.remove("active"));

        button.classList.add("active");
        if (button.dataset.unit === "in") {
          sizeChartTableInches.classList.add("active");
          activeUnit = "in";
        } else if (button.dataset.unit === "cm") {
          sizeChartTableCm.classList.add("active");
          activeUnit = "cm";
        }
      });
    });

    // Reinitialize observer on window resize with debounce
    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        observer.disconnect();
        const newOptions = getObserverOptions();
        const newObserver = new IntersectionObserver(
          observerCallback,
          newOptions
        );

        newObserver.observe(howToMeasureDiv);
        if (activeUnit === "in") {
          newObserver.observe(sizeChartTableInches);
        } else {
          newObserver.observe(sizeChartTableCm);
        }
      }, 200);
    });
  }

  // Size Selection and ATC functionality.
  productVariants = getVariantData();
  function getVariantData() {
    let variantData = JSON.parse(
      document
        .querySelector(".size-chart-wrapper")
        .querySelector('[type="application/json"]').textContent
    );

    return variantData;
  }

  // Helper function to sync radio inputs between 'in' and 'cm' tables
  function syncActiveState() {
    if (isSyncing) return;
    isSyncing = true;
    const selectedInchesRadio = document.querySelector(
      ".input-radios-in:checked"
    );
    if (!selectedInchesRadio) {
      const firstInchesRadio = document.querySelector(
        ".input-radios-in:not([disabled])"
      );
      if (firstInchesRadio) {
        firstInchesRadio.checked = true;
        firstInchesRadio.dispatchEvent(new Event("change"));
      } else {
        isSyncing = false;
        return;
      }
    }

    const selectedVariant = selectedInchesRadio?.value;
    const selectedCmRadio = document.querySelector(
      `.table-wrapper-cm .input-radios[value="${selectedVariant}"]`
    );
    if (selectedCmRadio) {
      setActiveState(selectedCmRadio, selectedVariant, "cm");
    }

    isSyncing = false;
  }

  // Helper function to set the active state for the given variant in the table
  function setActiveState(radioInput) {
    if (radioInput) {
      radioInput.checked = true;
      const activeRow = radioInput.closest(".selectable-row");
      activeRow.classList.add("active");
    }
  }

  // Helper function to disable unavailable variants across tables
  function disableUnavailableVariants() {
    const radios = document.querySelectorAll(".input-radios");
    radios.forEach((radio) => {
      const variantValue = radio.dataset.variantId;
      const variant = productVariants.find((v) => v.id == variantValue);
      const row = radio.closest(".selectable-row");
      if (variant && !variant.available) {
        radio.setAttribute("disabled", "disabled");
        if (row) {
          row.classList.add("disabled");
        }
      } else {
        radio.removeAttribute("disabled");
        if (row) {
          row.classList.remove("disabled");
        }
      }
    });
  }

  // Function to initialize event listeners and handle the selection of rows
  function initializeRowSelection() {
    const rows = document.querySelectorAll(".selectable-row");
    const selectedRadios = document.querySelectorAll(".input-radios:checked");
    rows.forEach((row) => row.classList.remove("active"));
    selectedRadios.forEach((selectedRadio) => {
      const selectedVariant = selectedRadio.value;
      const activeRow = Array.from(rows).find(
        (row) => row.dataset.variant === selectedVariant
      );

      productVariants.forEach((variant) => {
        if (!variant.available) {
          selectedRadio.setAttribute("disabled", "disabled");

          const disabledRow = Array.from(rows).find(
            (row) => row.dataset.variantId == variant.id
          );

          if (disabledRow) {
            disabledRow.classList.add("disabled");
            disabledRow.classList.remove("active");
          }
        } else {
          if (activeRow) {
            activeRow.classList.remove("disabled");
            activeRow.classList.add("active");
          }
        }
      });
    });

    rows.forEach((row) => {
      const radioInput = row.querySelector(".input-radios");
      if (radioInput) {
        row.addEventListener("click", function () {
          // Remove "active" only from rows that are not this one
          rows.forEach((r) => r.classList.remove("active"));
          // Add "active" to the clicked row
          this.classList.add("active");
          // HulkappWishlist.init();
          if (!radioInput.checked) {
            radioInput.checked = true;
            radioInput.dispatchEvent(new Event("change"));
          }
        });
      }
    });
  }

  // Handle initial variant selection and ATC button state
  productVariants.forEach((variant) => {
    if (variant.id == currentVariantInUrl) {
      document.querySelectorAll('input[name="variant"]').forEach((input) => {
        if (input.dataset.variantId === currentVariantInUrl) {
          input.checked = true;
          selectedSizeForSizeChart = variant.id;
          input.classList.add("checked-class");
        }
      });

      let addToCartButton = document.querySelector(
        ".custom-add-to-cart-button"
      );
      let wishlistButton = document.querySelector(".wishlist-button");

      if (addToCartButton && wishlistButton) {
        if (!variant.available) {
          addToCartButton.setAttribute("disabled", "disabled");
          addToCartButton.textContent = "Sold Out";
          wishlistButton.setAttribute("disabled", "disabled");
        } else {
          addToCartButton.removeAttribute("disabled");
          addToCartButton.textContent = "Add To Cart";
          wishlistButton.removeAttribute("disabled");
        }
      }
    }
  });

  // Event listener for size change on PDP
  function attachVariantChangeListeners() {
    document.querySelectorAll('input[name="variant"]').forEach((input) => {
      input.removeEventListener("change", handleSizeChange);
      input.addEventListener("change", handleSizeChange);
    });
  }

  // Event listener for product variant change
  document.addEventListener("product:variant-change", (e) => {
    e.preventDefault();
    checkVariantQuantityInCart(e.detail.variant.id);
    clearTimeout(debounceTimer);
    let selectedSize;
    debounceTimer = setTimeout(() => {
      document.querySelectorAll('input[name="Size"]').forEach((input) => {
        if (input.checked) {
          selectedSize = input.value;
        }
      });
      selectedSizeForSizeChart = e.detail.variant.id;
      centralVariantChangeHandler(selectedSize);
    }, 200);
    let addToCartButton = document.querySelector(".custom-add-to-cart-button");
    let wishlistButton = document.querySelector(".wishlist-button");

    if (addToCartButton && wishlistButton) {
      if (!e.detail.variant.available) {
        addToCartButton.setAttribute("disabled", "disabled");
        addToCartButton.textContent = "Sold Out";
        wishlistButton.setAttribute("disabled", "disabled");
      } else {
        addToCartButton.removeAttribute("disabled");
        addToCartButton.textContent = "Add To Cart";
        wishlistButton.removeAttribute("disabled");
      }
    }
  });

  // Central handler to sync size selection across size chart and PDP
  function centralVariantChangeHandler(selectedSize) {
    document.querySelectorAll('input[name="variant"]').forEach((input) => {
      input.classList.remove("checked-class");
    });

    document.querySelectorAll('input[name="variant"]').forEach((input) => {
      if (input.value.trim() === selectedSize) {
        input.checked = true;
        input.classList.add("checked-class");
      }
    });

    document.querySelectorAll('input[name="Size"]').forEach((input) => {
      if (input.value.trim() === selectedSize) {
        input.checked = true;
        selectedSize = input.value;
      }
    });

    disableUnavailableVariants();
    initializeRowSelection();
    syncActiveState();
    checkVariantQuantityInCart(selectedSizeForSizeChart);
    // HulkappWishlist.init();
  }

  // Size change handler for PDP
  function handleSizeChange(e) {
    const selectedSize = e.target.value;
    centralVariantChangeHandler(selectedSize);
  }

  function reAttachEventListeners() {
    const variantInputs = document.querySelectorAll('input[name="variant"]');
    variantInputs.forEach((input) => {
      const clonedInput = input.cloneNode(true);
      input.parentNode.replaceChild(clonedInput, input);
      clonedInput.addEventListener("change", handleVariantChange);
    });
    handleClickForATC();
    handleScrollforTabs("in");
  }

  const handleVariantChange = (event) => {
    if (event.target.checked) {
      document.querySelectorAll("input.checked-class").forEach((label) => {
        label.classList.remove("checked-class");
      });

      event.target.classList.add("checked-class");
      const selectedSize = event.target.value;

      document.querySelectorAll('input[name="Size"]').forEach((sizeInput) => {
        if (sizeInput.value.trim() === selectedSize) {
          sizeInput.checked = true;
        }
      });

      document.querySelector(".variant-selects").onVariantChange();
      refreshPage(".main-product-section");
    }
  };

  // ATC click handler
  function handleClickForATC() {
    document
      .querySelector(".custom-add-to-cart-button")
      .addEventListener("click", (e) => {
        document.querySelector(".custom-add-to-cart-button").innerHTML = `
      <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <style>
          .spinner_P7sC {
            transform-origin: center;
            animation: spinner_svv2 .75s infinite linear;
          }
          @keyframes spinner_svv2 {
            100% {
              transform: rotate(360deg);
            }
          }
        </style>
        <path fill="#000" d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z" class="spinner_P7sC" />
      </svg>
      `;

        const formData = new FormData();
        formData?.append("id", selectedSizeForSizeChart);
        checkVariantQuantityInCart(selectedSizeForSizeChart);
        addToCart(formData);
        document.dispatchEvent(new CustomEvent("cart:item-added"));
      });
  }

  // Function to update the URL with the selected variant ID
  function updateUrl(variantId) {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set("variant", variantId);
    // window.history.replaceState({}, "", currentUrl);
  }

  // Function to refresh part of the page
  async function refreshPage(selector) {
    const response = await fetch(window.location.href);
    const data = await response.text();
    const parser = new DOMParser();
    const html = parser.parseFromString(data, "text/html");
    const source = html.querySelector(selector);
    const destination = document.querySelector(selector);

    if (source && destination) {
      destination.innerHTML = source.innerHTML;
    }
    Shopify.PaymentButton.init();
    window.scrollTo(0, 0);
    const offersButton = document.querySelector(".offers-wrapper-pdp");
    if (offersButton) {
      offersButton.addEventListener("click", (event) => {
        event.stopPropagation();
        showPopup();
        copyPDPOffers();
      });
    }
    document.querySelector(".close-popup") &&
      document
        .querySelector(".close-popup")
        .addEventListener("click", (event) => {
          event.stopPropagation();
          closePopup();
        });
  }

  // Add to cart function
  function addToCart(formData) {
    document
      .querySelector(".custom-add-to-cart-button")
      .setAttribute("disabled", "disabled");
    fetch("/cart/add.js", {
      method: "POST",
      body: formData,
    })
      .then(async (response) => {
        if (!response.ok) {
          const text = await response.text();
          throw new Error(
            `Failed to add item to cart: ${response.statusText} (${response.status}) - ${text}`
          );
        }
        return response.json();
      })
      .then(() => {
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        document.querySelector(".product-popup-modal").removeAttribute("open");
        document.body.classList.add("open-cc");
        document.body.classList.add("open-cart");
        document.getElementById("Cart-Drawer").classList.add("active");
        window.scrollTo(0, 0);
        document.querySelector(".product-popup-modal").hide();
        document
          .querySelector(".custom-add-to-cart-button")
          .removeAttribute("disabled");
        document.querySelector(".custom-add-to-cart-button").innerHTML =
          "Add To Cart";

        window.fetchAndRenderCartCrossSell();
      })
      .catch((error) => {
        console.error("Error adding item to cart:", error);
      });
  }

  async function fetchCartData() {
    try {
      const response = await fetch("/cart.js");
      const cartData = await response.json();
      return cartData.items;
    } catch (error) {
      console.error("Error fetching cart data:", error);
      return [];
    }
  }

  function checkVariantQuantityInCart(variantId) {
    fetchCartData()
      .then((cartItems) => {
        let variantQuantityInCart = 0;
        cartItems.forEach((item) => {
          if (item.variant_id === variantId) {
            variantQuantityInCart += item.quantity;
          }
        });
        const inventory = document.querySelectorAll(".inventory-div");

        let inventoryQuantity;

        inventory.forEach((variant) => {
          if (variant.dataset.id == variantId) {
            inventoryQuantity = Number(variant.dataset.inventory);
          }
        });
        if (variantQuantityInCart >= Number(inventoryQuantity)) {
          disableUnavailableVariants();
          document
            .querySelector(".custom-add-to-cart-button")
            .setAttribute("disabled", "disabled");
          let warningMessage = document.querySelector(".cart-warning-message");
          if (!warningMessage && inventoryQuantity != 0) {
            warningMessage = document.createElement("div");
            warningMessage.className = "cart-warning-message";
            warningMessage.textContent = "Maximum quantity reached.";
            document
              .querySelector(".custom-add-to-cart-button")
              .appendChild(warningMessage);
          }
        } else {
          document
            .querySelector(".custom-add-to-cart-button")
            .removeAttribute("disabled");
          const warningMessage = document.querySelector(
            ".cart-warning-message"
          );
          if (warningMessage) {
            warningMessage.remove();
          }
        }
      })
      .catch((error) => {
        console.error("Error checking variant quantity in cart:", error);
      });
  }

  document.addEventListener("DOMContentLoaded", () => {
    reAttachEventListeners();
    disableUnavailableVariants();
    initializeRowSelection();
    syncActiveState();
    handleScrollforTabs("in");
    checkVariantQuantityInCart(selectedSizeForSizeChart);
  });

  // document.querySelector(".wishlist-button").addEventListener("click", () => {
  //   HulkappWishlist.init();
  // });
}

// PDP Offers
const offersButton = document.querySelector(".offers-wrapper-pdp");
if (offersButton) {
  offersButton.addEventListener("click", (event) => {
    event.stopPropagation();
    showPopup();
  });
}

function showPopup() {
  const popupContainer = document.querySelector(".pop-up-wrapper");
  popupContainer.classList.add("active");
  document.body.classList.add("no-scroll");

  // Add click listener to close the popup when clicking outside
  document.addEventListener("click", outsideClickListener);
}

function closePopup() {
  const popupContainer = document.querySelector(".pop-up-wrapper");
  popupContainer.classList.remove("active");
  document.body.classList.remove("no-scroll");

  // Remove the click listener when popup is closed
  document.removeEventListener("click", outsideClickListener);
}

function outsideClickListener(event) {
  const popupContainer = document.querySelector(".pop-up-container");
  if (
    !popupContainer.contains(event.target) &&
    !offersButton.contains(event.target)
  ) {
    closePopup();
  }
}

document.querySelector(".close-popup") && document.querySelector(".close-popup").addEventListener("click", (event) => {
  event.stopPropagation();
  closePopup();
});

// PDP Offers - Copy Button
function copyPDPOffers() {
  const copyButtons = document.querySelectorAll(".coupon-button-pdp");
  copyButtons.forEach((element) => {
    element.addEventListener("click", () => {
      const copiedText = element.getAttribute("data-copied-value");
      navigator.clipboard
        .writeText(copiedText)
        .then(() => {
          showCopyMessage(copiedText);
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
        });
    });
  });

  function showCopyMessage(text) {
    const messageElement = document.querySelector(".copy-message");
    messageElement.textContent = `Code ${text} copied! Time to save big!`;
    messageElement.classList.add("active");
    document.querySelector(".pop-up-container").scrollTo({
      top: 0,
      behavior: "smooth",
    });
    setTimeout(() => {
      messageElement.classList.remove("active");
    }, 1000);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  copyPDPOffers();
});

class ReorderAtc extends HTMLElement {
  constructor() {
    super();
    this.addToCartButton = this.querySelector('#product-atc-button');
  }

  connectedCallback() {
    this.addToCart(this.addToCartButton);
  }

  getSectionsToRender() {
    return [
      {
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }
    ];
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach(section => {
      const sectionElement = document.getElementById(section.id);
      if (!sectionElement) return;

      const elementToReplace = sectionElement.querySelector(section.selector) || sectionElement;
      if (parsedState.sections?.[section.section]) {
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }

      if (typeof CartDrawer !== 'undefined') {
        new CartDrawer();
      }
      if (typeof Cart !== 'undefined') {
        new Cart().renderContents(parsedState);
      }
    });

    let productDrawer = document.getElementById('Product-Drawer');
    if (productDrawer && productDrawer.contains(this)) {
      productDrawer.querySelector('.product-quick-images--container').classList.remove('active');
      document.body.classList.remove('open-quick-view');

      if (window.innerWidth < 1069) {
        productDrawer.classList.remove('active');
        const cartDrawer = document.getElementById('Cart-Drawer');
        if (cartDrawer) {
          cartDrawer.classList.add('active');
          document.body.classList.add('open-cart');
          cartDrawer.querySelector('.product-recommendations--full')?.classList.add('active');
          dispatchCustomEvent('cart-drawer:open');
        }
      } else {
        productDrawer.querySelector('.product-quick-images--container').addEventListener('transitionend', function () {
          productDrawer.classList.remove('active');

          const cartDrawer = document.getElementById('Cart-Drawer');
          if (cartDrawer) {
            cartDrawer.classList.add('active');
            document.body.classList.add('open-cart');
            cartDrawer.querySelector('.product-recommendations--full')?.classList.add('active');
            dispatchCustomEvent('cart-drawer:open');
          }
        });
      }

      if (!document.getElementById('Cart-Drawer')) {
        document.body.classList.remove('open-cc');
      }
    } else if (document.getElementById('Cart-Drawer')) {
      document.body.classList.add('open-cc', 'open-cart');
      document.getElementById('Cart-Drawer').classList.add('active');
      dispatchCustomEvent('cart-drawer:open');
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML || html;
  }

  addToCart(addToCartButton) {
    if (!addToCartButton) return;

    addToCartButton.addEventListener("click", async (event) => {
      event.preventDefault();

      const submitButton = event.currentTarget;
      const variantID = addToCartButton.dataset.variantId;

      if (!variantID) {
        console.error("❌ Variant ID not found.");
        return;
      }

      submitButton.setAttribute("aria-disabled", true);
      submitButton.classList.add("loading");

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
            "Accept": "application/javascript"
          },
          body: JSON.stringify({
            items: [{ id: parseInt(variantID, 10), quantity: 1 }],
            sections: this.getSectionsToRender().map(section => section.section),
            sections_url: window.location.pathname
          })
        });

        const cartData = await response.json();
        
        if (cartData.status) {
          console.error("❌ Error adding to cart:", cartData.message);
          alert(cartData.message);
          return;
        }

        // ✅ Update sections and open cart drawer
        this.renderContents(cartData);

        document.dispatchEvent(new CustomEvent("cart:item-added", {
          detail: { product: cartData.items?.[0] || cartData }
        }));

      } catch (error) {
        console.error("⚠️ Fetch Error:", error);
        alert("Failed to add product to cart.");
      } finally {
        submitButton.classList.remove("loading");
        submitButton.removeAttribute("aria-disabled");
      }
    });
  }
}

customElements.define('reorder-atc', ReorderAtc);


// ---------------------------------------------------
document.addEventListener('DOMContentLoaded', function () {
  const kidsLink = document.querySelector('[data-item-title="Kids"]');
  const kidsMenu = document.getElementById('custom-kids-menu');

  if (kidsLink && kidsMenu) {
    let hoverTimeout;

    const showMenu = () => {
      clearTimeout(hoverTimeout);
      kidsMenu.classList.add('active');
    };

    const hideMenu = () => {
      hoverTimeout = setTimeout(() => {
        kidsMenu.classList.remove('active');
      }, 200); // small delay to avoid flickering
    };

    kidsLink.addEventListener('mouseenter', showMenu);
    kidsLink.addEventListener('mouseleave', hideMenu);
    kidsMenu.addEventListener('mouseenter', showMenu);
    kidsMenu.addEventListener('mouseleave', hideMenu);
  }

});

class addonCheckBox extends HTMLElement {
  constructor() {
    super();

    // bind once so `this` works correctly
    this.onClick = this.onClick.bind(this);
  }

  connectedCallback() {
    // attach when element is added to DOM (works for quick view)
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    // clean up when quick view is destroyed
    this.removeEventListener('click', this.onClick);
  }

  onClick(e) {
    const wrapper = e.target.closest('[data-clickable]');
    if (!wrapper || !this.contains(wrapper)) return;

    if (wrapper.classList.contains('freebie--disabled')) return;

    const checkbox = wrapper.querySelector('#freebie-product-checkbox');
    if (!checkbox || checkbox.disabled) return;

    // 🔑 If the actual checkbox was clicked, do nothing
    if (e.target === checkbox) {
      wrapper.classList.toggle('freebie--selected', checkbox.checked);
      return;
    }

    // Tile click → toggle checkbox manually
    checkbox.checked = !checkbox.checked;
    wrapper.classList.toggle('freebie--selected', checkbox.checked);
  }
}

customElements.define('addon-checkbox', addonCheckBox);